import { Link } from '@remix-run/react';

import { ResponsiveImageSet } from '~/types/Taxon';

// Rendered width per the consuming `<Col md={6}>` grid: one column (100vw) below the `md`
// (768px) breakpoint, two columns (50vw) from 768px up — this covers both the mobile <img>'s
// own active range (<992px, split at 768px) and the desktop <source>'s (>=992px, always 50vw).
const BANNER_SIZES = '(max-width: 767px) 100vw, 50vw';

interface BannerProps {
  image: {
    desktop: string;
    mobile: string;
    desktopSet?: ResponsiveImageSet;
    mobileSet?: ResponsiveImageSet;
  };
  link?: string;
  alt?: string;
  title?: string;
  subtitle?: string;
  buttonTitle?: string;
  onClick?: () => void;
}

const Banner = ({ image, link, alt = '', title, subtitle, buttonTitle, onClick }: BannerProps) => {
  return (
    <Link to={link || '#'} className="banner" aria-label={alt || title} onClick={onClick}>
      <picture>
        <source
          media="(min-width: 992px)"
          srcSet={image.desktopSet?.srcset ?? image.desktop}
          sizes={image.desktopSet ? BANNER_SIZES : undefined}
        />
        <img
          src={image.mobileSet?.src ?? image.mobile}
          srcSet={image.mobileSet?.srcset}
          sizes={image.mobileSet ? BANNER_SIZES : undefined}
          className="banner__image"
          alt={alt || title || ''}
          loading="lazy"
          fetchpriority="low"
          decoding="async"
          width={515}
          height={400}
        />
      </picture>
      {(title || subtitle || buttonTitle) && (
        <div className="banner__content">
          {title && <strong className="h3 banner__title">{title}</strong>}
          {subtitle && <p className="banner__subtitle">{subtitle}</p>}
          {buttonTitle && <span className="banner__button btn">{buttonTitle}</span>}
        </div>
      )}
    </Link>
  );
};

export default Banner;
